import Script from "next/script";

export function ExternalWidgetXolaContent() {
    return (
        <>
            <Script id="external-widget-xola" src="https://xola.com/checkout.js" async={true} />
        </>
    );
}
